// extracted by mini-css-extract-plugin
export default {"informationBox":"InformationBox_informationBox__4BeEh"};